import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { adminService, ingresosService, serviciosService, galeriaService, diasBloqueadosService, URL_FOTOS } from "../../services/api";
import CalendarioTurnos from "./CalendarioTurnos";
import CheckAnimado from "../Animaciones/CheckAnimado";
import "./Admin.css";

const _CATEGORIAS_CATALOGO = [
  { id: "manos", label: "Uñas · Manos" },
  { id: "pies", label: "Uñas · Pies" },
  { id: "otros", label: "Otros servicios" },
  { id: "pestanas", label: "Pestañas" },
  { id: "mantenimientos", label: "Mantenimientos" },
];

const _CATEGORIAS_GALERIA = [
  { id: "todos", label: "Todos" },
  { id: "unas", label: "Uñas" },
  { id: "pestanas", label: "Pestañas" },
];

function Admin() {
  const [vistaActiva, setVistaActiva] = useState("dashboard");
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [vistaTurnos, setVistaTurnos] = useState("tabla");
  const [dashboard, setDashboard] = useState(null);
  const [turnos, setTurnos] = useState([]);
  const [clientas, setClientas] = useState([]);
  const [ingresos, setIngresos] = useState([]);
  const [resumenIngresos, setResumenIngresos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [toastGuardado, setToastGuardado] = useState(false);
  const [formularioTurno, setFormularioTurno] = useState({
    emailClienta: "",
    servicio: "",
    fechaHora: "",
    notas: "",
    precio: "",
  });
  const [formularioClienta, setFormularioClienta] = useState({
    nombre: "",
    email: "",
    telefono: "",
    instagram: "",
  });
  const [formularioIngreso, setFormularioIngreso] = useState({
    servicio: "",
    clientaNombre: "",
    monto: "",
    notas: "",
  });
  const [catalogo, setCatalogo] = useState([]);
  const [categoriaCatalogoActiva, setCategoriaCatalogoActiva] = useState("manos");
  const [modoEdicionServicio, setModoEdicionServicio] = useState(false);
  const [servicioEditando, setServicioEditando] = useState(null);
  const [formularioServicio, setFormularioServicio] = useState({ categoria: "manos", nombre: "", detalle: "", precio: "", orden: 0, disponibleParaReserva: true });
  const [fotos, setFotos] = useState([]);
  const [filtroGaleriaAdmin, setFiltroGaleriaAdmin] = useState("todos");
  const [subiendoFoto, setSubiendoFoto] = useState(false);
  const [categoriaSubidaFoto, setCategoriaSubidaFoto] = useState("unas");
  const [diasBloqueados, setDiasBloqueados] = useState([]);
  const [formularioDiaBloqueado, setFormularioDiaBloqueado] = useState({ fecha: "", motivo: "" });
  const [guardandoDiaBloqueado, setGuardandoDiaBloqueado] = useState(false);
  const [itemsCalculadora, setItemsCalculadora] = useState([]);
  const [categoriaCalculadoraActiva, setCategoriaCalculadoraActiva] = useState("manos");
  const [busquedaCalculadora, setBusquedaCalculadora] = useState("");
  const [clienteIdCalculadora, setClienteIdCalculadora] = useState("");
  const [clientaCalculadora, setClientaCalculadora] = useState("");
  const [registrandoCalculadora, setRegistrandoCalculadora] = useState(false);
  const [clientaSeleccionada, setClientaSeleccionada] = useState(null);
  const [notasClienta, setNotasClienta] = useState("");
  const [guardandoNotas, setGuardandoNotas] = useState(false);
  const [instagramClienta, setInstagramClienta] = useState("");
  const [guardandoInstagram, setGuardandoInstagram] = useState(false);
  const [convirtiendoAdmin, setConvirtiendoAdmin] = useState(false);
  const [clienteIdIngreso, setClienteIdIngreso] = useState("");
  const [busquedaClienta, setBusquedaClienta] = useState("");
  const [errorCarga, setErrorCarga] = useState("");
  const [reintentandoCarga, setReintentandoCarga] = useState(false);
  const navigate = useNavigate();

  const _nombre = localStorage.getItem("nombre");

  useEffect(() => {
    const _esAdmin = localStorage.getItem("esAdmin");
    if (!_esAdmin || _esAdmin === "false") {
      navigate("/login");
    }
    cargarDatos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const _esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const _intentarCargarUnaVez = async () => {
    const _tareas = [
      { nombre: "dashboard", promesa: adminService.obtenerDashboard(), setter: setDashboard },
      { nombre: "turnos", promesa: adminService.obtenerTodosTurnos(), setter: setTurnos },
      { nombre: "clientas", promesa: adminService.obtenerClientas(), setter: setClientas },
      { nombre: "ingresos", promesa: ingresosService.obtenerTodos(), setter: setIngresos },
      { nombre: "resumen de ingresos", promesa: ingresosService.obtenerResumen(), setter: setResumenIngresos },
      { nombre: "catálogo", promesa: serviciosService.obtenerTodos(), setter: setCatalogo },
      { nombre: "galería", promesa: galeriaService.obtenerTodas(), setter: setFotos },
      { nombre: "días bloqueados", promesa: diasBloqueadosService.obtenerTodos(), setter: setDiasBloqueados },
    ];

    const _resultados = await Promise.allSettled(_tareas.map((t) => t.promesa));

    const _fallidas = [];
    _resultados.forEach((resultado, indice) => {
      const _tarea = _tareas[indice];
      if (resultado.status === "fulfilled") {
        _tarea.setter(resultado.value.data);
      } else {
        console.error(`Error al cargar ${_tarea.nombre}`, resultado.reason);
        _fallidas.push(_tarea.nombre);
      }
    });

    return _fallidas;
  };

  const cargarDatos = async () => {
    setCargando(true);
    setErrorCarga("");
    setReintentandoCarga(false);
    try {
      const _demorasReintento = [0, 3000, 6000, 10000, 15000, 20000, 20000];
      let _fallidas = [];

      for (let _intento = 0; _intento < _demorasReintento.length; _intento++) {
        if (_intento > 0) {
          setReintentandoCarga(true);
          await _esperar(_demorasReintento[_intento]);
        }

        _fallidas = await _intentarCargarUnaVez();

        if (_fallidas.length === 0) break;
      }

      setReintentandoCarga(false);
      setErrorCarga(
        _fallidas.length > 0
          ? `No se pudo actualizar: ${_fallidas.join(", ")}. Tocá "Actualizar" para reintentar.`
          : ""
      );
    } finally {
      setCargando(false);
    }
  };

  const abrirNuevoServicio = () => {
    setServicioEditando(null);
    setFormularioServicio({ categoria: categoriaCatalogoActiva, nombre: "", detalle: "", precio: "", orden: 99, disponibleParaReserva: true });
    setModoEdicionServicio(true);
  };

  const abrirEditarServicio = (servicio) => {
    setServicioEditando(servicio);
    setFormularioServicio({
      categoria: servicio.categoria,
      nombre: servicio.nombre,
      detalle: servicio.detalle,
      precio: servicio.precio,
      orden: servicio.orden,
      disponibleParaReserva: servicio.disponibleParaReserva !== undefined ? servicio.disponibleParaReserva : true,
    });
    setModoEdicionServicio(true);
  };

  const mostrarToastGuardado = () => {
    setToastGuardado(true);
    setTimeout(() => setToastGuardado(false), 1800);
  };

  const guardarServicio = async (e) => {
    e.preventDefault();
    try {
      const _datos = { ...formularioServicio, precio: parseFloat(formularioServicio.precio), orden: parseInt(formularioServicio.orden) };
      if (servicioEditando) {
        await serviciosService.editar(servicioEditando.id, _datos);
      } else {
        await serviciosService.crear(_datos);
      }
      setModoEdicionServicio(false);
      cargarDatos();
      mostrarToastGuardado();
    } catch (error) {
      alert("Error al guardar el servicio");
    }
  };

  const eliminarServicio = async (id) => {
    if (window.confirm("Estas segura que queres eliminar este servicio?")) {
      try {
        await serviciosService.eliminar(id);
        cargarDatos();
      } catch (error) {
        alert("Error al eliminar");
      }
    }
  };

  const manejarSubidaFoto = async (e) => {
    const _archivo = e.target.files[0];
    if (!_archivo) return;

    setSubiendoFoto(true);
    try {
      await galeriaService.subirFoto(_archivo, categoriaSubidaFoto);
      cargarDatos();
    } catch (error) {
      alert("Error al subir la foto");
    } finally {
      setSubiendoFoto(false);
      e.target.value = "";
    }
  };

  const agregarDiaBloqueado = async (e) => {
    e.preventDefault();
    if (!formularioDiaBloqueado.fecha) return;

    setGuardandoDiaBloqueado(true);
    try {
      await diasBloqueadosService.crear(formularioDiaBloqueado);
      setFormularioDiaBloqueado({ fecha: "", motivo: "" });
      cargarDatos();
    } catch (error) {
      alert(error.response?.data || "Error al bloquear el día");
    } finally {
      setGuardandoDiaBloqueado(false);
    }
  };

  const eliminarDiaBloqueado = async (id) => {
    if (window.confirm("¿Desbloquear este día? Va a volver a estar disponible para reservar.")) {
      try {
        await diasBloqueadosService.eliminar(id);
        cargarDatos();
      } catch (error) {
        alert("Error al desbloquear el día");
      }
    }
  };

  const eliminarFotoAdmin = async (id) => {
    if (window.confirm("Estas segura que queres eliminar esta foto?")) {
      try {
        await galeriaService.eliminarFoto(id);
        cargarDatos();
      } catch (error) {
        alert("Error al eliminar la foto");
      }
    }
  };

  const cerrarSesion = () => {
    localStorage.clear();
    navigate("/");
  };

  const cambiarEstadoTurno = async (id, estado) => {
    try {
      await adminService.cambiarEstadoTurno(id, estado);
      cargarDatos();
    } catch (error) {
      console.error("Error al cambiar estado", error);
    }
  };

  const agregarTurno = async (e) => {
    e.preventDefault();
    try {
      await adminService.agregarTurno({
        ...formularioTurno,
        precio: parseFloat(formularioTurno.precio),
      });
      alert("Turno agregado correctamente");
      setFormularioTurno({ emailClienta: "", servicio: "", fechaHora: "", notas: "", precio: "" });
      cargarDatos();
    } catch (error) {
      alert("Error al agregar turno. Verifica que el email de la clienta exista.");
    }
  };

  const agregarClienta = async (e) => {
    e.preventDefault();
    try {
      await adminService.agregarClienta(formularioClienta);
      alert("Clienta agregada correctamente");
      setFormularioClienta({ nombre: "", email: "", telefono: "", instagram: "" });
      cargarDatos();
    } catch (error) {
      alert("Error al agregar clienta. El email ya puede estar registrado.");
    }
  };

  const agregarIngreso = async (e) => {
    e.preventDefault();
    try {
      await ingresosService.agregarIngreso({
        ...formularioIngreso,
        monto: parseFloat(formularioIngreso.monto),
        clienteId: clienteIdIngreso && clienteIdIngreso !== "otra" ? parseInt(clienteIdIngreso) : null,
      });
      alert("Ingreso registrado correctamente");
      setFormularioIngreso({ servicio: "", clientaNombre: "", monto: "", notas: "" });
      setClienteIdIngreso("");
      cargarDatos();
    } catch (error) {
      alert("Error al registrar ingreso");
    }
  };

  const eliminarIngreso = async (id) => {
    if (window.confirm("Estas segura que queres eliminar este ingreso?")) {
      try {
        await ingresosService.eliminarIngreso(id);
        cargarDatos();
      } catch (error) {
        alert("Error al eliminar ingreso");
      }
    }
  };

  const agregarItemCalculadora = (variante) => {
    setItemsCalculadora((prev) => {
      const _existe = prev.find((i) => i.id === variante.id);
      if (_existe) {
        return prev.map((i) => i.id === variante.id ? { ...i, cantidad: i.cantidad + 1 } : i);
      }
      return [...prev, { id: variante.id, nombre: variante.nombre, detalle: variante.detalle, precio: variante.precio, cantidad: 1 }];
    });
  };

  const quitarUnoCalculadora = (id) => {
    setItemsCalculadora((prev) =>
      prev
        .map((i) => i.id === id ? { ...i, cantidad: i.cantidad - 1 } : i)
        .filter((i) => i.cantidad > 0)
    );
  };

  const eliminarItemCalculadora = (id) => {
    setItemsCalculadora((prev) => prev.filter((i) => i.id !== id));
  };

  const limpiarCalculadora = () => {
    setItemsCalculadora([]);
    setClienteIdCalculadora("");
    setClientaCalculadora("");
  };

  const registrarCalculadoraComoIngreso = async () => {
    if (itemsCalculadora.length === 0) return;
    setRegistrandoCalculadora(true);
    try {
      const _descripcion = itemsCalculadora
        .map((i) => {
          const _base = i.detalle ? `${i.nombre} (${i.detalle})` : i.nombre;
          return i.cantidad > 1 ? `${_base} x${i.cantidad}` : _base;
        })
        .join(", ");
      await ingresosService.agregarIngreso({
        servicio: _descripcion,
        clientaNombre: clientaCalculadora || "Sin especificar",
        monto: _totalCalculadora,
        notas: "",
        clienteId: clienteIdCalculadora && clienteIdCalculadora !== "otra" ? parseInt(clienteIdCalculadora) : null,
      });
      alert("Ingreso registrado correctamente");
      limpiarCalculadora();
      cargarDatos();
    } catch (error) {
      alert("Error al registrar ingreso");
    } finally {
      setRegistrandoCalculadora(false);
    }
  };

  const abrirPerfilClienta = (clienta) => {
    setClientaSeleccionada(clienta);
    setNotasClienta(clienta.notas || "");
    setInstagramClienta(clienta.instagram || "");
  };

  const abrirPerfilDeTurno = (turno) => {
    if (!turno.usuario) return;
    const _clienta = clientas.find((c) => c.id === turno.usuario.id) || { ...turno.usuario, turnos: [] };
    abrirPerfilClienta(_clienta);
  };

  const cerrarPerfilClienta = () => {
    setClientaSeleccionada(null);
    setNotasClienta("");
    setInstagramClienta("");
  };

  const guardarNotasClienta = async () => {
    if (!clientaSeleccionada) return;
    setGuardandoNotas(true);
    try {
      await adminService.actualizarNotasClienta(clientaSeleccionada.id, notasClienta);
      setClientas((prev) =>
        prev.map((c) => (c.id === clientaSeleccionada.id ? { ...c, notas: notasClienta } : c))
      );
      setClientaSeleccionada((prev) => prev && { ...prev, notas: notasClienta });
      mostrarToastGuardado();
    } catch (error) {
      alert("Error al guardar las notas");
    } finally {
      setGuardandoNotas(false);
    }
  };

  const guardarInstagramClienta = async () => {
    if (!clientaSeleccionada) return;
    setGuardandoInstagram(true);
    try {
      await adminService.actualizarInstagramClienta(clientaSeleccionada.id, instagramClienta);
      setClientas((prev) =>
        prev.map((c) => (c.id === clientaSeleccionada.id ? { ...c, instagram: instagramClienta } : c))
      );
      setClientaSeleccionada((prev) => prev && { ...prev, instagram: instagramClienta });
      mostrarToastGuardado();
    } catch (error) {
      alert("Error al guardar el Instagram");
    } finally {
      setGuardandoInstagram(false);
    }
  };

  const convertirEnAdmin = async () => {
    if (!clientaSeleccionada) return;
    if (!window.confirm(`¿Convertir a ${clientaSeleccionada.nombre} en administradora? Va a poder entrar al panel admin con su cuenta.`)) {
      return;
    }
    setConvirtiendoAdmin(true);
    try {
      await adminService.hacerAdmin(clientaSeleccionada.id);
      alert("Listo, ahora es administradora");
      cerrarPerfilClienta();
      cargarDatos();
    } catch (error) {
      alert("Error al convertir en administradora");
    } finally {
      setConvirtiendoAdmin(false);
    }
  };

  const _turnosHoy = turnos.filter(t => {
    const _fecha = new Date(t.fechaHora);
    const _hoy = new Date();
    return _fecha.toDateString() === _hoy.toDateString();
  });

  const _turnosProximos = turnos.filter(t => {
    const _fecha = new Date(t.fechaHora);
    return _fecha > new Date() && t.estado !== "Cancelado";
  }).slice(0, 5);

  const _itemsMenu = [
    { id: "dashboard", icono: "📊", label: "Dashboard" },
    { id: "turnos", icono: "📅", label: "Turnos" },
    { id: "clientas", icono: "👥", label: "Clientas" },
    { id: "ingresos", icono: "💰", label: "Ingresos" },
    { id: "calculadora", icono: "🧮", label: "Calculadora" },
    { id: "servicios", icono: "💇", label: "Servicios y precios" },
    { id: "galeria", icono: "🖼", label: "Galería" },
    { id: "dias-bloqueados", icono: "🚫", label: "Días bloqueados" },
    { id: "agregar-turno", icono: "➕", label: "Nuevo turno" },
    { id: "agregar-clienta", icono: "👤", label: "Nueva clienta" },
  ];

  const _catalogoFiltrado = catalogo.filter((s) => s.categoria === categoriaCatalogoActiva);
  const _catalogoAgrupado = _catalogoFiltrado.reduce((acc, s) => {
    const _grupo = acc.find((g) => g.nombre === s.nombre);
    if (_grupo) {
      _grupo.variantes.push(s);
    } else {
      acc.push({ nombre: s.nombre, variantes: [s] });
    }
    return acc;
  }, []);

  const _fotosFiltradasAdmin = filtroGaleriaAdmin === "todos"
    ? fotos
    : fotos.filter((foto) => foto.categoria === filtroGaleriaAdmin);

  const _clientasFiltradas = busquedaClienta.trim() === ""
    ? clientas
    : clientas.filter((c) => {
        const _texto = busquedaClienta.trim().toLowerCase();
        return (
          c.nombre?.toLowerCase().includes(_texto) ||
          c.email?.toLowerCase().includes(_texto) ||
          c.telefono?.toLowerCase().includes(_texto)
        );
      });

  const _catalogoFiltradoCalc = catalogo.filter((s) => s.categoria === categoriaCalculadoraActiva);
  const _catalogoAgrupadoCalc = _catalogoFiltradoCalc.reduce((acc, s) => {
    const _grupo = acc.find((g) => g.nombre === s.nombre);
    if (_grupo) {
      _grupo.variantes.push(s);
    } else {
      acc.push({ nombre: s.nombre, variantes: [s] });
    }
    return acc;
  }, []);

  const _busquedaCalcTexto = busquedaCalculadora.trim().toLowerCase();
  const _catalogoBusquedaCalc = _busquedaCalcTexto
    ? catalogo
        .filter(
          (s) =>
            s.nombre?.toLowerCase().includes(_busquedaCalcTexto) ||
            s.detalle?.toLowerCase().includes(_busquedaCalcTexto)
        )
        .reduce((acc, s) => {
          const _grupo = acc.find((g) => g.nombre === s.nombre);
          if (_grupo) {
            _grupo.variantes.push(s);
          } else {
            acc.push({ nombre: s.nombre, variantes: [s] });
          }
          return acc;
        }, [])
    : null;
  const _catalogoParaMostrarCalc = _catalogoBusquedaCalc ?? _catalogoAgrupadoCalc;
  const _totalCalculadora = itemsCalculadora.reduce((acc, i) => acc + i.precio * i.cantidad, 0);

  const _historialClienta = clientaSeleccionada
    ? [
        ...(clientaSeleccionada.turnos || []).map((t) => ({
          tipo: "turno",
          fecha: t.fechaHora,
          servicio: t.servicio,
          monto: t.precio,
          estado: t.estado,
        })),
        ...ingresos
          .filter((i) => i.clienteId === clientaSeleccionada.id)
          .map((i) => ({
            tipo: "ingreso",
            fecha: i.fecha,
            servicio: i.servicio,
            monto: i.monto,
            estado: null,
          })),
      ].sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    : [];

  if (cargando) {
    return (
      <div className="admin-cargando">
        <div className="admin-spinner"></div>
        <p>{reintentandoCarga ? "El servidor se está despertando, esto puede tardar hasta un minuto..." : "Cargando panel..."}</p>
      </div>
    );
  }

  return (
    <div className="admin-pagina">
      {toastGuardado && (
        <div className="admin-toast-guardado">
          <CheckAnimado />
          <span>Guardado</span>
        </div>
      )}

      <div className="admin-topbar-mobile">
        <span className="admin-topbar-titulo">Hola, {_nombre}</span>
        <button
          className="admin-menu-toggle"
          onClick={() => setMenuAbierto(!menuAbierto)}
          aria-label="Abrir menú"
        >
          <span className={"admin-menu-linea " + (menuAbierto ? "abierta" : "")}></span>
          <span className={"admin-menu-linea " + (menuAbierto ? "abierta" : "")}></span>
          <span className={"admin-menu-linea " + (menuAbierto ? "abierta" : "")}></span>
        </button>
      </div>

      <aside className={"admin-sidebar " + (menuAbierto ? "admin-sidebar-abierto" : "")}>
        <div className="admin-sidebar-logo" onClick={() => navigate("/")}>
          <img src="/logo-glowroom.png" alt="Glowroom MVD" className="admin-logo-img" />
          <span className="admin-logo-texto">Volver al inicio</span>
        </div>

        <nav className="admin-nav">
          {_itemsMenu.map((item) => (
            <button
              key={item.id}
              className={`admin-nav-item ${vistaActiva === item.id ? "activo" : ""}`}
              onClick={() => { setVistaActiva(item.id); setMenuAbierto(false); }}
            >
              <span className="admin-nav-icono">{item.icono}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <p className="admin-bienvenida">Hola, {_nombre}</p>
          <button className="admin-cerrar-sesion" onClick={cerrarSesion}>
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="admin-contenido">
        {errorCarga && (
          <div className="admin-aviso-error">
            ⚠ {errorCarga}
          </div>
        )}
        {vistaActiva === "dashboard" && dashboard && resumenIngresos && (
          <div className="admin-seccion">
            <h1 className="admin-titulo">Panel administrador de la mas preciosa 😘</h1>
            <div className="admin-stats-grid">
              <div className="admin-stat-card destacado">
                <span className="admin-stat-icono">💰</span>
                <span className="admin-stat-numero">${resumenIngresos.hoy}</span>
                <span className="admin-stat-label">Ingresos hoy</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">📅</span>
                <span className="admin-stat-numero">${resumenIngresos.semana}</span>
                <span className="admin-stat-label">Esta semana</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">📆</span>
                <span className="admin-stat-numero">${resumenIngresos.mes}</span>
                <span className="admin-stat-label">Este mes</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">👥</span>
                <span className="admin-stat-numero">{dashboard.totalClientas}</span>
                <span className="admin-stat-label">Clientas totales</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">⏳</span>
                <span className="admin-stat-numero">{dashboard.turnosPendientes}</span>
                <span className="admin-stat-label">A confirmar</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">✅</span>
                <span className="admin-stat-numero">{dashboard.turnosConfirmados}</span>
                <span className="admin-stat-label">Confirmados</span>
              </div>
            </div>

            <div className="admin-dashboard-grid">
              <div className="admin-card">
                <h3 className="admin-card-titulo">Turnos de hoy</h3>
                {_turnosHoy.length === 0 ? (
                  <p className="admin-sin-datos">No hay turnos para hoy</p>
                ) : (
                  <div className="admin-lista-turnos">
                    {_turnosHoy.map((turno) => (
                      <div key={turno.id} className="admin-turno-item fila-clickeable" onClick={() => abrirPerfilDeTurno(turno)}>
                        <div className="admin-turno-hora">
                          {new Date(turno.fechaHora).toLocaleTimeString("es-UY", { hour: "2-digit", minute: "2-digit" })}
                        </div>
                        <div className="admin-turno-info">
                          <p className="admin-turno-nombre">{turno.usuario?.nombre || "—"}</p>
                          <p className="admin-turno-servicio">{turno.servicio}</p>
                        </div>
                        <span className={`admin-estado ${turno.estado.toLowerCase().replace(" ", "-")}`}>
                          {turno.estado}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="admin-card">
                <h3 className="admin-card-titulo">Proximos turnos</h3>
                {_turnosProximos.length === 0 ? (
                  <p className="admin-sin-datos">No hay turnos proximos</p>
                ) : (
                  <div className="admin-lista-turnos">
                    {_turnosProximos.map((turno) => (
                      <div key={turno.id} className="admin-turno-item fila-clickeable" onClick={() => abrirPerfilDeTurno(turno)}>
                        <div className="admin-turno-hora">
                          {new Date(turno.fechaHora).toLocaleDateString("es-UY", { day: "2-digit", month: "2-digit" })}
                        </div>
                        <div className="admin-turno-info">
                          <p className="admin-turno-nombre">{turno.usuario?.nombre || "—"}</p>
                          <p className="admin-turno-servicio">{turno.servicio}</p>
                        </div>
                        <span className={`admin-estado ${turno.estado.toLowerCase().replace(" ", "-")}`}>
                          {turno.estado}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {vistaActiva === "turnos" && (
          <div className="admin-seccion">
            <div className="admin-seccion-header">
              <h1 className="admin-titulo">Turnos</h1>
              <div className="admin-vista-selector">
                <button
                  className={`vista-btn ${vistaTurnos === "tabla" ? "activo" : ""}`}
                  onClick={() => setVistaTurnos("tabla")}
                >
                  Lista
                </button>
                <button
                  className={`vista-btn ${vistaTurnos === "calendario" ? "activo" : ""}`}
                  onClick={() => setVistaTurnos("calendario")}
                >
                  Calendario
                </button>
                <button className="btn-rosa" onClick={cargarDatos}>Actualizar</button>
              </div>
            </div>

            {vistaTurnos === "tabla" ? (
              <div className="admin-tabla-contenedor">
                <table className="admin-tabla">
                  <thead>
                    <tr>
                      <th>Clienta</th>
                      <th>Servicio</th>
                      <th>Fecha y hora</th>
                      <th>Precio</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {turnos.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="admin-sin-datos-tabla">No hay turnos registrados</td>
                      </tr>
                    ) : (
                      turnos.map((turno) => (
                        <tr key={turno.id} className="fila-clickeable" onClick={() => abrirPerfilDeTurno(turno)}>
                          <td data-label="Clienta">{turno.usuario?.nombre || "—"}</td>
                          <td data-label="Servicio">{turno.servicio}</td>
                          <td data-label="Fecha y hora">{new Date(turno.fechaHora).toLocaleString("es-UY")}</td>
                          <td data-label="Precio">${turno.precio}</td>
                          <td data-label="Estado">
                            <span className={`admin-estado ${turno.estado.toLowerCase().replace(" ", "-")}`}>
                              {turno.estado}
                            </span>
                          </td>
                          <td className="admin-acciones" data-label="Acciones" onClick={(e) => e.stopPropagation()}>
                            <button className="btn-accion confirmar" title="Confirmar" onClick={() => cambiarEstadoTurno(turno.id, "Confirmado")}>✓</button>
                            <button className="btn-accion completar" title="Trabajo realizado" onClick={() => cambiarEstadoTurno(turno.id, "Completado")}>★</button>
                            <button className="btn-accion cancelar" title="Cancelar" onClick={() => cambiarEstadoTurno(turno.id, "Cancelado")}>✕</button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <CalendarioTurnos turnos={turnos} />
            )}
          </div>
        )}

        {vistaActiva === "clientas" && (
          <div className="admin-seccion">
            <h1 className="admin-titulo">Clientas</h1>
            <p className="admin-subtitulo">Buscá y tocá una clienta para ver su historial y sus notas.</p>

            <input
              type="text"
              className="formulario-input admin-buscador-clienta"
              placeholder="Buscar por nombre, email o teléfono..."
              value={busquedaClienta}
              onChange={(e) => setBusquedaClienta(e.target.value)}
            />

            <div className="admin-tabla-contenedor">
              <table className="admin-tabla">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Telefono</th>
                    <th>Turnos</th>
                    <th>Registro</th>
                  </tr>
                </thead>
                <tbody>
                  {_clientasFiltradas.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="admin-sin-datos-tabla">
                        {clientas.length === 0 ? "No hay clientas registradas" : "No se encontraron clientas con esa búsqueda"}
                      </td>
                    </tr>
                  ) : (
                    _clientasFiltradas.map((clienta) => (
                      <tr key={clienta.id} className="fila-clickeable" onClick={() => abrirPerfilClienta(clienta)}>
                        <td data-label="Nombre">{clienta.nombre}</td>
                        <td data-label="Email">{clienta.email}</td>
                        <td data-label="Telefono">{clienta.telefono || "—"}</td>
                        <td data-label="Turnos">{clienta.turnos?.length || 0}</td>
                        <td data-label="Registro">{new Date(clienta.fechaRegistro).toLocaleDateString("es-UY")}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {clientaSeleccionada && (
          <div className="servicio-modal-fondo" onClick={cerrarPerfilClienta}>
            <div className="servicio-modal perfil-clienta-modal" onClick={(e) => e.stopPropagation()}>
              <button className="servicio-modal-cerrar" onClick={cerrarPerfilClienta}>✕</button>
              <div className="perfil-clienta-header">
                <h3>{clientaSeleccionada.nombre}</h3>
                <button
                  className="perfil-clienta-hacer-admin"
                  onClick={convertirEnAdmin}
                  disabled={convirtiendoAdmin}
                >
                  {convirtiendoAdmin ? "Convirtiendo..." : "Convertir en administradora"}
                </button>
              </div>
              <p className="perfil-clienta-dato">{clientaSeleccionada.email}</p>
              <p className="perfil-clienta-dato">{clientaSeleccionada.telefono || "Sin telefono"}</p>
              <p className="perfil-clienta-dato">
                Clienta desde {new Date(clientaSeleccionada.fechaRegistro).toLocaleDateString("es-UY")}
              </p>

              <div className="formulario-grupo perfil-clienta-notas">
                <label className="formulario-label">Instagram</label>
                <input
                  type="text"
                  className="formulario-input"
                  value={instagramClienta}
                  onChange={(e) => setInstagramClienta(e.target.value)}
                  placeholder="@usuario_de_instagram"
                />
                <button
                  className="btn-principal perfil-clienta-guardar"
                  onClick={guardarInstagramClienta}
                  disabled={guardandoInstagram}
                >
                  {guardandoInstagram ? "Guardando..." : "Guardar Instagram"}
                </button>
              </div>

              <div className="formulario-grupo perfil-clienta-notas">
                <label className="formulario-label">Notas (talle, preferencias, alergias...)</label>
                <textarea
                  className="formulario-input formulario-textarea"
                  value={notasClienta}
                  onChange={(e) => setNotasClienta(e.target.value)}
                  placeholder="Ej: Talle de uña M, prefiere colores nude, alérgica al acrílico..."
                  rows={2}
                />
                <button
                  className="btn-principal perfil-clienta-guardar"
                  onClick={guardarNotasClienta}
                  disabled={guardandoNotas}
                >
                  {guardandoNotas ? "Guardando..." : "Guardar notas"}
                </button>
              </div>

              <h4 className="perfil-clienta-subtitulo">Historial de servicios</h4>
              {_historialClienta.length === 0 ? (
                <p className="admin-sin-datos">Todavía no tiene servicios registrados</p>
              ) : (
                <div className="perfil-clienta-historial">
                  {_historialClienta.map((item, _indice) => (
                    <div key={_indice} className="perfil-clienta-historial-item">
                      <div className="perfil-clienta-historial-info">
                        <span className="perfil-clienta-historial-servicio">{item.servicio}</span>
                        <span className="perfil-clienta-historial-fecha">
                          {new Date(item.fecha).toLocaleDateString("es-UY")}
                        </span>
                      </div>
                      <div className="perfil-clienta-historial-derecha">
                        {item.estado && (
                          <span className={`admin-estado ${item.estado.toLowerCase().replace(" ", "-")}`}>
                            {item.estado}
                          </span>
                        )}
                        <span className="perfil-clienta-historial-monto">${item.monto}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {vistaActiva === "ingresos" && (
          <div className="admin-seccion">
            <h1 className="admin-titulo">Ingresos</h1>

            <div className="admin-stats-grid">
              <div className="admin-stat-card destacado">
                <span className="admin-stat-icono">💰</span>
                <span className="admin-stat-numero">${resumenIngresos?.hoy || 0}</span>
                <span className="admin-stat-label">Hoy</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">📅</span>
                <span className="admin-stat-numero">${resumenIngresos?.semana || 0}</span>
                <span className="admin-stat-label">Esta semana</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">📆</span>
                <span className="admin-stat-numero">${resumenIngresos?.mes || 0}</span>
                <span className="admin-stat-label">Este mes</span>
              </div>
              <div className="admin-stat-card">
                <span className="admin-stat-icono">🏆</span>
                <span className="admin-stat-numero">${resumenIngresos?.total || 0}</span>
                <span className="admin-stat-label">Total historico</span>
              </div>
            </div>

            <div className="admin-ingresos-grid">
              <div className="admin-formulario-card">
                <h3 className="admin-card-titulo">Registrar trabajo</h3>
                <form className="admin-formulario" onSubmit={agregarIngreso}>
                  <div className="formulario-grupo">
                    <label className="formulario-label">Clienta</label>
                    <select
                      className="formulario-input"
                      value={clienteIdIngreso}
                      onChange={(e) => {
                        const _valor = e.target.value;
                        setClienteIdIngreso(_valor);
                        if (_valor && _valor !== "otra") {
                          const _clienta = clientas.find((c) => String(c.id) === _valor);
                          setFormularioIngreso({ ...formularioIngreso, clientaNombre: _clienta ? _clienta.nombre : "" });
                        } else {
                          setFormularioIngreso({ ...formularioIngreso, clientaNombre: "" });
                        }
                      }}
                      required
                    >
                      <option value="">Selecciona una clienta</option>
                      {clientas.map((c) => (
                        <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))}
                      <option value="otra">Otra (no registrada)</option>
                    </select>
                  </div>
                  {clienteIdIngreso === "otra" && (
                    <div className="formulario-grupo">
                      <label className="formulario-label">Nombre de la clienta</label>
                      <input
                        type="text"
                        className="formulario-input"
                        value={formularioIngreso.clientaNombre}
                        onChange={(e) => setFormularioIngreso({ ...formularioIngreso, clientaNombre: e.target.value })}
                        placeholder="Nombre de quien realizo el servicio"
                        required
                      />
                    </div>
                  )}
                  <div className="formulario-grupo">
                    <label className="formulario-label">Servicio realizado</label>
                    <select
                      className="formulario-input"
                      value={formularioIngreso.servicio}
                      onChange={(e) => setFormularioIngreso({ ...formularioIngreso, servicio: e.target.value })}
                      required
                    >
                      <option value="">Selecciona un servicio</option>
                      {catalogo.map((s) => (
                        <option key={s.id} value={s.detalle ? `${s.nombre} (${s.detalle})` : s.nombre}>
                          {s.detalle ? `${s.nombre} (${s.detalle})` : s.nombre} - ${s.precio}
                        </option>
                      ))}
                      <option value="Otro">Otro</option>
                    </select>
                  </div>
                  <div className="formulario-grupo">
                    <label className="formulario-label">Monto cobrado ($)</label>
                    <input
                      type="number"
                      className="formulario-input"
                      value={formularioIngreso.monto}
                      onChange={(e) => setFormularioIngreso({ ...formularioIngreso, monto: e.target.value })}
                      placeholder="890"
                      required
                    />
                  </div>
                  <div className="formulario-grupo">
                    <label className="formulario-label">Notas (opcional)</label>
                    <textarea
                      className="formulario-input formulario-textarea"
                      value={formularioIngreso.notas}
                      onChange={(e) => setFormularioIngreso({ ...formularioIngreso, notas: e.target.value })}
                      placeholder="Algun detalle del trabajo..."
                      rows={2}
                    />
                  </div>
                  <button type="submit" className="btn-principal">Registrar ingreso</button>
                </form>
              </div>

              <div className="admin-tabla-contenedor">
                <table className="admin-tabla">
                  <thead>
                    <tr>
                      <th>Clienta</th>
                      <th>Servicio</th>
                      <th>Monto</th>
                      <th>Fecha</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {ingresos.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="admin-sin-datos-tabla">No hay ingresos registrados</td>
                      </tr>
                    ) : (
                      ingresos.map((ingreso) => (
                        <tr key={ingreso.id}>
                          <td data-label="Clienta">{ingreso.clientaNombre}</td>
                          <td data-label="Servicio">{ingreso.servicio}</td>
                          <td data-label="Monto">${ingreso.monto}</td>
                          <td data-label="Fecha">{new Date(ingreso.fecha).toLocaleDateString("es-UY")}</td>
                          <td className="admin-acciones">
                            <button className="btn-accion cancelar" onClick={() => eliminarIngreso(ingreso.id)}>✕</button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {vistaActiva === "calculadora" && (
          <div className="admin-seccion">
            <h1 className="admin-titulo">Calculadora de precio final</h1>
            <p className="admin-subtitulo">
              Elegí todo lo que le hiciste a la clienta y se suma automático el total a cobrar.
            </p>

            <div className="calculadora-grid">
              <div className="calculadora-catalogo">
                <input
                  type="text"
                  className="calculadora-buscador"
                  placeholder="Buscar servicio por nombre..."
                  value={busquedaCalculadora}
                  onChange={(e) => setBusquedaCalculadora(e.target.value)}
                />

                {!_busquedaCalcTexto && (
                  <div className="servicios-tabs">
                    {_CATEGORIAS_CATALOGO.map((cat) => (
                      <button
                        key={cat.id}
                        className={"servicios-tab " + (categoriaCalculadoraActiva === cat.id ? "activo" : "")}
                        onClick={() => setCategoriaCalculadoraActiva(cat.id)}
                      >
                        {cat.label}
                      </button>
                    ))}
                  </div>
                )}

                {_catalogoParaMostrarCalc.length === 0 ? (
                  <p className="admin-sin-datos">
                    {_busquedaCalcTexto
                      ? "No se encontraron servicios"
                      : "No hay servicios cargados en esta categoría"}
                  </p>
                ) : (
                  <div className="calculadora-items-lista">
                    {_catalogoParaMostrarCalc.map((grupo) => (
                      <div key={grupo.nombre} className="calculadora-grupo">
                        <div className="calculadora-grupo-nombre">{grupo.nombre}</div>
                        <div className="calculadora-grupo-opciones">
                          {grupo.variantes.map((variante) => (
                            <button
                              key={variante.id}
                              className="calculadora-item-btn"
                              onClick={() => agregarItemCalculadora(variante)}
                            >
                              {variante.detalle && (
                                <span className="calculadora-item-detalle">{variante.detalle}</span>
                              )}
                              <span className="calculadora-item-precio">${variante.precio}</span>
                            </button>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="calculadora-ticket">
                <h3 className="admin-card-titulo">Ticket</h3>

                {itemsCalculadora.length === 0 ? (
                  <p className="admin-sin-datos">Todavía no elegiste ningún servicio</p>
                ) : (
                  <div className="calculadora-ticket-lista">
                    {itemsCalculadora.map((item) => (
                      <div key={item.id} className="calculadora-ticket-item">
                        <div className="calculadora-ticket-item-info">
                          <span className="calculadora-ticket-item-nombre">
                            {item.nombre}{item.detalle ? ` (${item.detalle})` : ""}
                          </span>
                          <span className="calculadora-ticket-item-precio">${item.precio} c/u</span>
                        </div>
                        <div className="calculadora-ticket-item-acciones">
                          <button className="btn-accion" onClick={() => quitarUnoCalculadora(item.id)}>−</button>
                          <span className="calculadora-ticket-cantidad">{item.cantidad}</span>
                          <button className="btn-accion confirmar" onClick={() => agregarItemCalculadora(item)}>+</button>
                          <button className="btn-accion cancelar" onClick={() => eliminarItemCalculadora(item.id)}>✕</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="calculadora-total">
                  <span>Total</span>
                  <span className="calculadora-total-numero">${_totalCalculadora}</span>
                </div>

                <div className="formulario-grupo">
                  <label className="formulario-label">Clienta (opcional)</label>
                  <select
                    className="formulario-input"
                    value={clienteIdCalculadora}
                    onChange={(e) => {
                      const _valor = e.target.value;
                      setClienteIdCalculadora(_valor);
                      if (_valor && _valor !== "otra") {
                        const _clienta = clientas.find((c) => String(c.id) === _valor);
                        setClientaCalculadora(_clienta ? _clienta.nombre : "");
                      } else {
                        setClientaCalculadora("");
                      }
                    }}
                  >
                    <option value="">Sin especificar</option>
                    {clientas.map((c) => (
                      <option key={c.id} value={c.id}>{c.nombre}</option>
                    ))}
                    <option value="otra">Otra (no registrada)</option>
                  </select>
                </div>
                {clienteIdCalculadora === "otra" && (
                  <div className="formulario-grupo">
                    <label className="formulario-label">Nombre</label>
                    <input
                      type="text"
                      className="formulario-input"
                      value={clientaCalculadora}
                      onChange={(e) => setClientaCalculadora(e.target.value)}
                      placeholder="Nombre de la clienta"
                    />
                  </div>
                )}

                <div className="calculadora-botones">
                  <button className="btn-secundario" onClick={limpiarCalculadora} disabled={itemsCalculadora.length === 0}>
                    Limpiar
                  </button>
                  <button
                    className="btn-principal"
                    onClick={registrarCalculadoraComoIngreso}
                    disabled={itemsCalculadora.length === 0 || registrandoCalculadora}
                  >
                    {registrandoCalculadora ? "Registrando..." : "Registrar como ingreso"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {vistaActiva === "servicios" && (
          <div className="admin-seccion">
            <div className="admin-seccion-header">
              <h1 className="admin-titulo">Servicios y precios</h1>
              <button className="btn-rosa" onClick={abrirNuevoServicio}>+ Agregar servicio</button>
            </div>

            <div className="servicios-tabs">
              {_CATEGORIAS_CATALOGO.map((cat) => (
                <button
                  key={cat.id}
                  className={"servicios-tab " + (categoriaCatalogoActiva === cat.id ? "activo" : "")}
                  onClick={() => setCategoriaCatalogoActiva(cat.id)}
                >
                  {cat.label}
                </button>
              ))}
            </div>

            <div className="admin-card">
              {_catalogoAgrupado.length === 0 ? (
                <p className="admin-sin-datos">No hay servicios cargados en esta categoría</p>
              ) : (
                <div className="servicios-lista">
                  {_catalogoAgrupado.map((grupo) => (
                    <div key={grupo.nombre} className="servicio-fila">
                      <div className="servicio-fila-nombre">{grupo.nombre}</div>
                      <div className="servicio-fila-opciones">
                        {grupo.variantes.map((variante) => (
                          <div key={variante.id} className="servicio-opcion">
                            {variante.detalle && (
                              <span className="servicio-opcion-detalle">{variante.detalle}</span>
                            )}
                            <span className="servicio-opcion-precio">${variante.precio}</span>
                            <div className="servicio-admin-acciones">
                              <button className="btn-editar-servicio" onClick={() => abrirEditarServicio(variante)}>Editar</button>
                              <button className="btn-eliminar-servicio" onClick={() => eliminarServicio(variante.id)}>✕</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {modoEdicionServicio && (
              <div className="servicio-modal-fondo" onClick={() => setModoEdicionServicio(false)}>
                <div className="servicio-modal" onClick={(e) => e.stopPropagation()}>
                  <button className="servicio-modal-cerrar" onClick={() => setModoEdicionServicio(false)}>✕</button>
                  <h3>{servicioEditando ? "Editar servicio" : "Nuevo servicio"}</h3>
                  <form onSubmit={guardarServicio} className="servicio-modal-form">
                    <div className="formulario-grupo">
                      <label className="formulario-label">Categoría</label>
                      <select
                        className="formulario-input"
                        value={formularioServicio.categoria}
                        onChange={(e) => setFormularioServicio({ ...formularioServicio, categoria: e.target.value })}
                      >
                        {_CATEGORIAS_CATALOGO.map((cat) => (
                          <option key={cat.id} value={cat.id}>{cat.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="formulario-grupo">
                      <label className="formulario-label">Nombre</label>
                      <input
                        type="text"
                        className="formulario-input"
                        value={formularioServicio.nombre}
                        onChange={(e) => setFormularioServicio({ ...formularioServicio, nombre: e.target.value })}
                        required
                      />
                    </div>
                    <div className="formulario-grupo">
                      <label className="formulario-label">Detalle (opcional)</label>
                      <input
                        type="text"
                        className="formulario-input"
                        value={formularioServicio.detalle}
                        onChange={(e) => setFormularioServicio({ ...formularioServicio, detalle: e.target.value })}
                        placeholder="Ej: Liso / simple"
                      />
                    </div>
                    <div className="formulario-grupo">
                      <label className="formulario-label">Precio</label>
                      <input
                        type="number"
                        className="formulario-input"
                        value={formularioServicio.precio}
                        onChange={(e) => setFormularioServicio({ ...formularioServicio, precio: e.target.value })}
                        required
                      />
                    </div>
                    <div className="formulario-grupo formulario-grupo-checkbox">
                      <label className="formulario-label-checkbox">
                        <input
                          type="checkbox"
                          checked={formularioServicio.disponibleParaReserva}
                          onChange={(e) => setFormularioServicio({ ...formularioServicio, disponibleParaReserva: e.target.checked })}
                        />
                        Disponible para reservar online
                      </label>
                    </div>
                    <button type="submit" className="btn-principal">Guardar</button>
                  </form>
                </div>
              </div>
            )}
          </div>
        )}

        {vistaActiva === "galeria" && (
          <div className="admin-seccion">
            <div className="admin-seccion-header">
              <h1 className="admin-titulo">Galería</h1>
              <div className="admin-galeria-controles">
                <select
                  className="admin-galeria-select"
                  value={categoriaSubidaFoto}
                  onChange={(e) => setCategoriaSubidaFoto(e.target.value)}
                >
                  <option value="unas">Uñas</option>
                  <option value="pestanas">Pestañas</option>
                </select>
                <label className="btn-rosa admin-galeria-boton">
                  {subiendoFoto ? "Subiendo..." : "+ Subir foto"}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={manejarSubidaFoto}
                    disabled={subiendoFoto}
                    style={{ display: "none" }}
                  />
                </label>
              </div>
            </div>

            <div className="galeria-filtros">
              {_CATEGORIAS_GALERIA.map((filtro) => (
                <button
                  key={filtro.id}
                  className={`filtro-btn ${filtroGaleriaAdmin === filtro.id ? "activo" : ""}`}
                  onClick={() => setFiltroGaleriaAdmin(filtro.id)}
                >
                  {filtro.label}
                </button>
              ))}
            </div>

            {_fotosFiltradasAdmin.length === 0 ? (
              <p className="admin-sin-datos">Todavía no hay fotos en esta categoría. Subí la primera!</p>
            ) : (
              <div className="galeria-grid">
                {_fotosFiltradasAdmin.map((foto) => (
                  <div key={foto.id} className="galeria-item">
                    <img
                      src={`${URL_FOTOS}/${foto.nombreArchivo}`}
                      alt="Trabajo Glowroom MVD"
                      className="galeria-foto"
                    />
                    <button className="galeria-eliminar" onClick={() => eliminarFotoAdmin(foto.id)}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {vistaActiva === "dias-bloqueados" && (
          <div className="admin-seccion">
            <h1 className="admin-titulo">Días bloqueados</h1>
            <p className="admin-subtitulo">
              Los días que bloquees acá no van a aparecer disponibles para reservar en la web.
            </p>

            <div className="admin-formulario-card">
              <form className="admin-formulario admin-formulario-fila" onSubmit={agregarDiaBloqueado}>
                <div className="formulario-grupo">
                  <label className="formulario-label">Fecha</label>
                  <input
                    type="date"
                    className="formulario-input"
                    value={formularioDiaBloqueado.fecha}
                    onChange={(e) => setFormularioDiaBloqueado({ ...formularioDiaBloqueado, fecha: e.target.value })}
                    required
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Motivo (opcional)</label>
                  <input
                    type="text"
                    className="formulario-input"
                    value={formularioDiaBloqueado.motivo}
                    onChange={(e) => setFormularioDiaBloqueado({ ...formularioDiaBloqueado, motivo: e.target.value })}
                    placeholder="Ej: Vacaciones, feriado, trámite..."
                  />
                </div>
                <button type="submit" className="btn-principal" disabled={guardandoDiaBloqueado}>
                  {guardandoDiaBloqueado ? "Bloqueando..." : "Bloquear día"}
                </button>
              </form>
            </div>

            <div className="admin-tabla-contenedor">
              <table className="admin-tabla">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Motivo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {diasBloqueados.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="admin-sin-datos-tabla">No hay días bloqueados</td>
                    </tr>
                  ) : (
                    diasBloqueados.map((dia) => (
                      <tr key={dia.id}>
                        <td data-label="Fecha" style={{ textTransform: "capitalize" }}>
                          {new Date(dia.fecha).toLocaleDateString("es-UY", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
                        </td>
                        <td data-label="Motivo">{dia.motivo || "—"}</td>
                        <td className="admin-acciones">
                          <button className="btn-accion cancelar" title="Desbloquear" onClick={() => eliminarDiaBloqueado(dia.id)}>✕</button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {vistaActiva === "agregar-turno" && (
          <div className="admin-seccion">
            <h1 className="admin-titulo">Nuevo turno</h1>
            <div className="admin-formulario-card">
              <form className="admin-formulario" onSubmit={agregarTurno}>
                <div className="formulario-grupo">
                  <label className="formulario-label">Email de la clienta</label>
                  <input
                    type="email"
                    className="formulario-input"
                    value={formularioTurno.emailClienta}
                    onChange={(e) => setFormularioTurno({ ...formularioTurno, emailClienta: e.target.value })}
                    placeholder="email@ejemplo.com"
                    required
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Servicio</label>
                  <select
                    className="formulario-input"
                    value={formularioTurno.servicio}
                    onChange={(e) => setFormularioTurno({ ...formularioTurno, servicio: e.target.value })}
                    required
                  >
                    <option value="">Selecciona un servicio</option>
                    {catalogo.map((s) => (
                      <option key={s.id} value={s.detalle ? `${s.nombre} (${s.detalle})` : s.nombre}>
                        {s.detalle ? `${s.nombre} (${s.detalle})` : s.nombre} - ${s.precio}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Fecha y hora</label>
                  <input
                    type="datetime-local"
                    className="formulario-input"
                    value={formularioTurno.fechaHora}
                    onChange={(e) => setFormularioTurno({ ...formularioTurno, fechaHora: e.target.value })}
                    required
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Precio ($)</label>
                  <input
                    type="number"
                    className="formulario-input"
                    value={formularioTurno.precio}
                    onChange={(e) => setFormularioTurno({ ...formularioTurno, precio: e.target.value })}
                    placeholder="890"
                    required
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Notas (opcional)</label>
                  <textarea
                    className="formulario-input formulario-textarea"
                    value={formularioTurno.notas}
                    onChange={(e) => setFormularioTurno({ ...formularioTurno, notas: e.target.value })}
                    placeholder="Notas adicionales..."
                    rows={3}
                  />
                </div>
                <button type="submit" className="btn-principal">Agregar turno</button>
              </form>
            </div>
          </div>
        )}

        {vistaActiva === "agregar-clienta" && (
          <div className="admin-seccion">
            <h1 className="admin-titulo">Nueva clienta</h1>
            <div className="admin-formulario-card">
              <form className="admin-formulario" onSubmit={agregarClienta}>
                <div className="formulario-grupo">
                  <label className="formulario-label">Nombre completo</label>
                  <input
                    type="text"
                    className="formulario-input"
                    value={formularioClienta.nombre}
                    onChange={(e) => setFormularioClienta({ ...formularioClienta, nombre: e.target.value })}
                    placeholder="Nombre de la clienta"
                    required
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Email</label>
                  <input
                    type="email"
                    className="formulario-input"
                    value={formularioClienta.email}
                    onChange={(e) => setFormularioClienta({ ...formularioClienta, email: e.target.value })}
                    placeholder="email@ejemplo.com"
                    required
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Telefono</label>
                  <input
                    type="tel"
                    className="formulario-input"
                    value={formularioClienta.telefono}
                    onChange={(e) => setFormularioClienta({ ...formularioClienta, telefono: e.target.value })}
                    placeholder="09X XXX XXX"
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Instagram</label>
                  <input
                    type="text"
                    className="formulario-input"
                    value={formularioClienta.instagram}
                    onChange={(e) => setFormularioClienta({ ...formularioClienta, instagram: e.target.value })}
                    placeholder="@usuario_de_instagram"
                  />
                </div>
                <button type="submit" className="btn-principal">Agregar clienta</button>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default Admin;